// extracted by mini-css-extract-plugin
export var externalLinkIcon = "_s6-5";
export var filledCircle = "_s6-4";
export var historyEntry = "_s6-3";
export var messageSideLeft = "_s6-1";
export var messageSideRight = "_s6-2";
export var orderTrackingCarouselWrapper = "_s6-6";
export var orderTrackingInfoContainer = "_s6-0";